/**
 * Shapes barrel for the strategy/planning vertical.
 *
 * Epic SP-A and SP-B expand the manifest list by adding
 * domain-specific construct shapes (task labels, section swimlanes,
 * scorecard total strips, radar facets, …). New manifests land next to
 * the existing ones under `shapes/gantt/` and `shapes/scorecard/` and
 * are appended to `PlanningShapeManifests` below.
 */

export { GanttTaskManifest, type GanttTaskProps } from './gantt/task.manifest';
export { GanttMilestoneManifest, type GanttMilestoneProps } from './gantt/milestone.manifest';
export { ScorecardOptionManifest, type ScorecardOptionProps } from './scorecard/option.manifest';
export { ScorecardCriterionManifest, type ScorecardCriterionProps } from './scorecard/criterion.manifest';
export { createPlanningManifest, type PlanningNodeProps } from './manifest-base';

import { GanttTaskManifest } from './gantt/task.manifest';
import { GanttMilestoneManifest } from './gantt/milestone.manifest';
import { ScorecardOptionManifest } from './scorecard/option.manifest';
import { ScorecardCriterionManifest } from './scorecard/criterion.manifest';

export const PlanningShapeManifests = [
  GanttTaskManifest,
  GanttMilestoneManifest,
  ScorecardOptionManifest,
  ScorecardCriterionManifest,
];
